import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.status = {
    key: 'status',
    label: translate('user.UserList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('user.UserList.Filter.StatusOptions'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
  };

  filterOptions.role = {
    key: 'role',
    label: translate('user.UserList.Filter.Role'),
    rank: 2,
    options: Object.entries(translate('user.UserList.Filter.RoleOptions'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
